/* KIBOU CURRY — スクロールに応じたフェードイン
   初期状態(.kc-reveal)は JS が付ける。読み込まれなければ何も隠れないので、
   JS 無効・エラー時にコンテンツが消える事故が起きない。 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  // 「まとまりごとに順に出す」対象と、「単体で出す」対象
  var GROUPS = ['.kc-points', '.kc-pills', '.kc-fact-ul', '.kc-says', '.kc-stats',
                '.kc-people', '.kc-gallery', '.kc-trio', '.kc-voices', '.kc-spec'];
  var SINGLES = ['.kc-section .kc-h2', '.kc-section .kc-lead', '.kc-facts__media',
                 '.kc-prose__body', '.kc-prose__media', '.kc-act', '.kc-award__inner',
                 '.kc-band__sub', '.kc-band__text', '.kc-table-wrap', '.kc-b2b',
                 '.kc-faq', '.kc-note'];

  var targets = [];
  function mark(el, delay) {
    if (!el || el.classList.contains('kc-reveal')) return;
    el.classList.add('kc-reveal');
    if (delay) el.setAttribute('data-kc-delay', String(Math.min(delay, 5)));
    targets.push(el);
  }

  GROUPS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) { mark(child, i); });
    });
  });
  SINGLES.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { mark(el, 0); });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  targets.forEach(function (el) { io.observe(el); });

  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    io.unobserve(el);
  }

  // 初期表示で既に画面内にあるものは、遅延なしで出す
  requestAnimationFrame(function () {
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) reveal(el);
    });
  });

  // 保険：IntersectionObserver が発火しない環境でも本文が消えないようにする。
  // 3秒経っても残っているものは無条件で表示する。
  setTimeout(function () { targets.forEach(reveal); }, 3000);
})();

/* KIBOU CURRY — 右下のお知らせ
   ・少しスクロールしてから出す（ファーストビューを塞がない）
   ・初回の訪問でだけ出す。一度出したら、お知らせの中身が変わるまで出さない（localStorage）
   ・複数あるときは一定間隔で入れ替える */
(function () {
  var el = document.querySelector('[data-kc-news]');
  if (!el) return;

  var items = el.querySelectorAll('[data-kc-news-item]');
  if (!items.length) return;

  // お知らせの見出しを並べた文字列を鍵にする。中身を差し替えたら、もう一度だけ出る
  var KEY = 'kc-news-seen';
  var sig = Array.prototype.map.call(items, function (n) { return n.textContent.replace(/\s+/g, ' ').trim(); }).join('|');
  try { if (localStorage.getItem(KEY) === sig) return; } catch (e) {}
  function remember() { try { localStorage.setItem(KEY, sig); } catch (e) {} }

  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    remember();
    el.hidden = false;
    // hidden 解除の直後だと transition が効かないので1フレーム待つ
    requestAnimationFrame(function () { el.classList.add('is-in'); });
  }
  function onScroll() {
    if (window.scrollY > window.innerHeight * 0.6) {
      show();
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // スクロールしない短いページでも必ず出す
  setTimeout(show, 6000);
  onScroll();

  var closeBtn = el.querySelector('[data-kc-news-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.hidden = true; }, 400);
      remember();
    });
  }

  if (items.length > 1) {
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-current');
      i = (i + 1) % items.length;
      items[i].classList.add('is-current');
    }, 7000);
  }
})();

/* KIBOU CURRY — 商品ページで「おすそ分け」を1食足す
   Dawn の main-product には手を入れず、この塊を購入ボタンの直前へ移してから
   フォーム送信を横取りして2品まとめてカートに入れる。

   注意：Dawn の <product-form> は form の submit に自前のハンドラを付けている
   （product-form.js: this.form.addEventListener('submit', ...)）。
   同じ form に後から listener を足すと両方が走り、主商品が二重に入る。
   そこで document のキャプチャ段階で受けて stopPropagation し、
   Dawn のハンドラへ到達させない。チェックが外れているときは何もしない。 */
(function () {
  var addon = document.querySelector('[data-kc-addon]');
  if (!addon) return;

  var form = document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  // 購入ボタンのすぐ上へ移す。見つからなければ元の位置のまま出す。
  var buttons = form.querySelector('.product-form__buttons');
  if (buttons) buttons.parentNode.insertBefore(addon, buttons);
  addon.hidden = false;

  var check = addon.querySelector('[data-kc-addon-check]');
  var giftId = addon.getAttribute('data-variant-id');
  if (!check || !giftId) return;

  // Dawn が用意するルート（言語・サブパス付きでも正しく効く）
  var R = window.routes || {};
  var addUrl = R.cart_add_url || '/cart/add';
  var cartUrl = R.cart_url || '/cart';

  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    if (!check.checked) return;          // Dawn の既定動作にまかせる

    e.preventDefault();
    e.stopPropagation();                 // Dawn の submit ハンドラを止める

    var data = new FormData(form);
    var mainId = data.get('id');
    var qty = parseInt(data.get('quantity') || '1', 10) || 1;
    if (!mainId) { form.submit(); return; }

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(mainId), quantity: qty },
          { id: Number(giftId), quantity: qty }
        ]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { window.location = cartUrl; })
      .catch(function () {
        // 失敗したら握りつぶさず、チェックを外して通常の送信に戻す
        if (btn) btn.removeAttribute('aria-disabled');
        check.checked = false;
        form.submit();
      });
  }, true);
})();
